import type { SnapshotBehaviourId } from "@healthos/shared";

export interface SnapshotBehaviourMeta {
  id: SnapshotBehaviourId;
  label: string;
  iconName: "moon" | "bowl-food" | "person-simple-walk" | "wind" | "heart";
  color: string;
  /** What has to arrive before the behaviour reads, shown while it is quiet. */
  feeds: string;
  /** Where the behaviour sits in the row list, which is not the radar's order. */
  row: number;
}

// The radar's own order, clockwise from the top: Sleep, Food, Movement,
// Stress, Connection. Each entry also carries the row list's order, which is a
// different one, so no surface has to keep a second list of ids in step.
// Correlations are NOT config: they arrive computed per user per week on
// payload.rows[id].correlates (production client data rule).
export const SNAPSHOT_BEHAVIOURS: ReadonlyArray<SnapshotBehaviourMeta> = [
  {
    id: "sleep",
    row: 0,
    label: "Sleep",
    iconName: "moon",
    color: "var(--color-ambient-sleep)",
    feeds: "a night from a wearable, or one you log",
  },
  {
    id: "food",
    row: 3,
    label: "Food",
    iconName: "bowl-food",
    color: "var(--color-ambient-energy)",
    feeds: "a logged meal",
  },
  {
    id: "movement",
    row: 1,
    label: "Movement",
    iconName: "person-simple-walk",
    color: "var(--color-teal-400)",
    feeds: "steps from a watch or phone",
  },
  {
    id: "stress",
    row: 2,
    label: "Stress",
    iconName: "wind",
    color: "var(--color-ambient-calm)",
    feeds: "heart rate variability, or a mood check-in",
  },
  {
    id: "connection",
    row: 4,
    label: "Connection",
    iconName: "heart",
    color: "var(--color-ambient-heart)",
    feeds: "a kudos or reaction in Community",
  },
];

// The one status-word scale, shared with the narrative orchestration so chips
// and prose can never disagree.

/** The behaviours in the order the rows read them, sleep first. */
export const SNAPSHOT_ROW_ORDER: ReadonlyArray<SnapshotBehaviourMeta> = [
  ...SNAPSHOT_BEHAVIOURS,
].sort((a, b) => a.row - b.row);
